<template>
    <div>
 
         
         <div class="columns is-multiline">
                                 
                                    <div class="column is-one-quarter-desktop is-half-tablet"   v-for="img in imgs" :key="img.id" >
                                    
 
                                            <div class="card-image  " @click="imageModal(img.path_img)">
                                                <figure class="image is-4by3"  >
                                                     <img :src="getURLImgWithUUID( img.path_img )"  >
                                                </figure>


                                                
                                            
                                            </div>
                                            <footer class="card-footer">
                                                <a class="card-footer-item" @click="imageModal(getURLImgWithUUID( img.path_img ))">
                                                    <b-icon
                                                            icon="magnify"
                                                            size="is-medium">
                                                    </b-icon>
                                                </a>

                                                <!-- <a class="card-footer-item"  @click="editCaptionImage(img.id_imr_obj,img.caption)" v-if="canAddImage">
                                                    <b-icon
                                                            icon="pencil"
                                                            type="is-warning"
                                                            size="is-medium">
                                                    </b-icon>
                                                </a> -->
                                                
                                                <a class="card-footer-item" @click="disableImage(img.id)" v-if="modeLabNewsElement==1">
                                                    <b-icon
                                                            icon="delete"
                                                            size="is-medium"
                                                            type="is-danger"
                                                            >
                                                    </b-icon>
                                                </a>


                                            </footer>
                                        




                                    </div>

                                    <!-- add new  -->
                                     <div class="column is-one-quarter-desktop is-half-tablet" v-if="modeLabNewsElement==1">
                                                <div class="">
                                                    <div class="">
                                                        <b-button type="is-primary" 
                                                        icon-left="plus-thick" 
                                                        outlined 
                                                        @click="showDlgImagesUploadBuffer">เพิ่มรูปประกอบ</b-button>
                                                    </div>
                                                </div>
                                     </div>
                            </div>   




                            <b-modal :active.sync="isImageModalActive">
                                <p class="image ">
                                    <img :src=dataUrl>
                                </p>
                            </b-modal>


                            <b-modal
                                    v-if="isDlgImagesUploadBufferShowing"
                                    v-model="isDlgImagesUploadBufferShowing"
                                    has-modal-card
                                    full-screen
                                    :can-cancel="true">
                                <DlgImagesUploadBuffer 
                                :isComponentModalActive="isDlgImagesUploadBufferShowing"  
                                :forJob="0"
                                @close="closeDlgImagesUploadBuffer"
                                @closeWithUpdate = "closeDlgImagesUploadBuffer_WithUpdate"/>
                            </b-modal>



    </div>
</template>


<script>
import {  genUUID , getBaseURLLabNewsV2  } from '@/utils.js'
import DlgImagesUploadBuffer from '../UtilsComponents/DlgImagesUploadBuffer/DlgImagesUploadBuffer.vue'
import {  mapState } from "vuex";
import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios , }  from '@/utils.js'




export default {
    name : "ImagesLabNewsListView",
    computed:{
          ...mapState({
            access_token: state => state.master_data.access_token ,
            labNewsElement : state => state.lab_news_element.labNewsElement ,
            modeLabNewsElement : state => state.lab_news_element.modeLabNewsElement ,
          })
    }, 
    components:{
        DlgImagesUploadBuffer,
    },
    props:{
        imgs : Array,
        canAddImage : Boolean,
    },
    methods:{
       


        closeDlgImagesUploadBuffer(){
            this.isDlgImagesUploadBufferShowing = false
        },
        closeDlgImagesUploadBuffer_WithUpdate(){
            this.$emit('updatedImage')
            this.isDlgImagesUploadBufferShowing = false
        },
        showDlgImagesUploadBuffer(){
           
           this.isDlgImagesUploadBufferShowing = true
        },




        getURLImgWithUUID(url_img){
           return `${getBaseURLLabNewsV2()}${url_img}?${genUUID(12)}` 
           // return `${url_img}?${genUUID(12)}` 
        },
        imageModal(dataUrl){
                if(dataUrl !== "") {
                    this.dataUrl = dataUrl
                }else{
                    this.dataUrl = 'imgnotaval.jpg'
                }
                this.isImageModalActive = true
                
        },
        disableImage(_id){
            // console.log(_id)
            const datTo={
                    "id_img" : _id
            }
            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
            axios.post(`${getBaseURLforBackEnd()}/api/disable_image_news`,datTo,getConfigAxios())
                 .then(()=>{
                    this.$emit('updatedImage')
                 })
        }
    },
    data(){
        return {
              isImageModalActive : false, 
              dataUrl : "",

              isDlgImagesUploadBufferShowing : false,
       
        }
    }
}
</script>




<style scoped>
    img{
        cursor: pointer;
        width:100%;
        height:100%;
        object-fit: contain;

    }
 
     .card-footer:hover{
       border: 3px solid rgb(139, 143, 140); 
    }


    .card-image{
       border: 1.5px solid rgb(166, 225, 182); 
    }

    .card-footer{
       border: 1.5px solid rgb(166, 225, 182); 
    }


</style>